import { compose, withState } from "recompose";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import * as selectors from "modules/booking/selectors";
import View from "./View";

export default compose(
  withState("isToggled", "toggleInput", false),
  withState("code", "setCode", void 0),
  connect(
    createStructuredSelector({
      coupon: selectors.applyPromoCodeApi
    })
  )
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/Payment/components/PromoCode/Provider.js